import { render, staticRenderFns } from "./UpdateComment.vue?vue&type=template&id=7b8d4db9&"
import script from "./UpdateComment.vue?vue&type=script&lang=js&"
export * from "./UpdateComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports